export const TOGGLE_MY_WATCHLIST_KEY = 'watchlist';
export const TOGGLE_ALL_COMMODITIES_KEY = 'all-commodities';
